import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DestinationFragment = {
  __typename: 'Destination';
  externalId: string;
  path: string;
  type: Types.DestinationType;
  icid: Types.Scalars['Map']['output'] | null;
};

export const DestinationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DestinationFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Destination' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'icid' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestinationFragment, unknown>;
